module.exports = __webpack_public_path__ + "static/media/Large Square Frames with Oversized Mat_0009.e0160a56.jpg";